import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { queryClient } from '@/lib/react-query';

export default function useFetchMessageOutput() {
  const { addNotification } = useNotificationStore();
  return useMutation(
    ({ metadata }) =>
      axios.get(
        `/api/v1/agent/report/conversation/output/${metadata.messageId}`
      ),
    {
      onSuccess: (data, { metadata }) => {
        if (metadata.flow === 'search') return;
        queryClient.setQueryData(
          ['explore-messages', metadata.conversationId],
          (prevData) => {
            let exploreConv = structuredClone(prevData || {});
            exploreConv.messages =
              exploreConv.messages?.map?.((message) => {
                if (message.messageId === metadata.messageId) {
                  message.finalOutput = data.outputs;
                }
                return message;
              }) || [];
            return exploreConv;
          }
        );
      },
      onError: (error) => {
        addNotification({ type: 'error', title: error.message });
      },
    }
  );
}
